site.topContent = {
	init: function () {
		var $body = $('body');

		var $topContent = $('#topContent');

		$('.wrapper', $topContent)
			.on('click', function (e) {
				//e.stopPropagation();
			})
			.append('<button class="close x rs_skip" aria-label="Close" />')
			.append('<div class="content" />')
		;

		$body.on('click', '#topContent .close', function (e) {
			$body.removeClass('topContent-open');
			site.topContent.clearHash();
			site.topContent.stopReadSpeaker();
		});

		// Close top content on body click, outside top content area
		$body.click(function (e) {
			if ($(e.target).parents('#topContent').length === 0 &&
				$(e.target).parents('#rs-controlpanel').length === 0 &&
				$body.hasClass('topContent-open')) {
				$body.removeClass('topContent-open');
				site.topContent.clearHash();
				site.topContent.stopReadSpeaker();
			}
		});

		// Close top content if escape key is pressed
		$(document).keyup(function (e) {
			if (e.keyCode === 27) {
				if ($body.hasClass('topContent-open')) {
					$body.removeClass('topContent-open');
					site.topContent.clearHash();
					site.topContent.stopReadSpeaker();
				}
			}
		});

		$body.on('click', 'a.topContent', function (e) {
			e.preventDefault();
			var $this = $(this),
				directUrl = $this.data('direct')
			;
			if (directUrl) {

				$.ajax({
					type: 'GET',
					url: directUrl,
					dataType: 'html',
					success: function (data) {
						site.topContent.appendData(data);
					},
				});
			}
			else {
				e.stopPropagation();

				site.topContent.loadPageContent(
					$(e.currentTarget).attr('href'),
					site.topContent.getLinkClassName($(this)),
				);
			}
			site.topContent.addHash($this.attr('data-topcontent'));
		});

		if ($('.virkCard.virkCard--tool').length) {
			site.toolsToogle.init();
		}

		site.topContent.openHash();
	},

	openHash: function () {
		var $hash = location.hash.substr(1);
		if ($hash.length > 0) {
			var $item = $('a[data-topcontent=' + $hash + ']');
			if ($item.length) {
				$item.trigger('click');
			}
		}
	},

	clearHash: function () {
		var scrollV, scrollH, loc = window.location;
		if ("pushState" in history)
			history.pushState("", document.title, loc.pathname + loc.search);
		else {
			// Prevent scrolling by storing the page's current scroll offset
			scrollV = document.body.scrollTop;
			scrollH = document.body.scrollLeft;

			loc.hash = "";

			// Restore the scroll offset, should be flicker free
			document.body.scrollTop = scrollV;
			document.body.scrollLeft = scrollH;
		}
	},

	addHash: function (hash) {
		location.hash = hash;
	},

	getLinkClassName: function (elm) {
		var className = '';
		if (elm.parents('li.si').length > 0) {
			var classList = elm.parents('li').attr('class');
			className = classList ? classList.match(/(\bicon-\S+\b)/ig) : '';

			if (className && Array.isArray(className)) {
				className = className[0];
			}
		}
		return className;
	},

	appendData: function (data) {
		$('.content', $('#topContent')).empty().append(data);
		$('body').addClass('topContent-open');
		$('.boxTitle h3', '#topContent').replaceWith(function () {
			return '<h1>' + $(this).html() + '</h1>';
		});
		$('.content section.accordion', $('#topContent')).each(function () {
			var $this = $(this);
			$('>*:not(:first-child)', $this).wrapAll('<div class="wrap" />');
			$('>:first-child', $this).contents().eq(0).wrap('<a href="#">');
			$this.addClass('ready');
		});
		site.accordion.initMaxHeight();
		site.accordion.hashOpen();
		site.accordion.followHash();
		site.topContent.contentLoaded();
	},

	lastPageUrl: '',
	loadPageContent: function (url, className) {
		if (site.topContent.lastPageUrl !== url) {
			$.get(url, function (data) {
				var $r = $(data);
				let button = $r.find('#readspeaker_button1');
				button.attr('id', 'readspeaker_button2');
				let aTag = button.find('.rsbtn_play')[0];
				aTag.href = aTag.href.replace('readid=main', 'readid=topContent');
				$r.find('.boxText .entry').prepend(button);
				site.topContent.appendData($('main', $r).html());
				$('#topContent').removeAttr('class').addClass(className);
			});
			site.topContent.lastPageUrl = url;
		}
		else {
			$('body').addClass('topContent-open');
		}
	},

	contentLoaded: function () {
		$('form', '#topContent').on('submit', function (e) {
			e.preventDefault();
			$.post($(this).attr('action'), $(this).serialize(), function (r) {
				var $data = $('main > .box', r);
				if ($data.length) {
					$data = $data.html();
				}
				else {
					$data = r;
				}
				site.topContent.appendData($data);
				site.topContent.contentLoaded();

				if (!$('form', $data).length) {
					site.topContent.lastPageUrl = '';
					var $refresh = $('.refresh', $data),
						url = $refresh.length ? $refresh.data('redirect') : '';
					if ($refresh.length) {
						setTimeout(function(){
							site.topContent.refresh(url);
						}, 1000);
					}
					else {
						$('#topContent .content')
							.append('<div class="closeWrap">' +
								'<button class="reload" onclick="location.reload()">Loka</button>' +
								'</div>');
					}
				}
			});
		});
		site.examCounter.init();
		site.toolsToogle.init();
		site.labelFocus.init();
	},

	refresh: function (url) {
		if (url) {
			window.location.href = url;
		}
		else {
			window.location.reload();
		}
	},
	stopReadSpeaker: function () {
		ReadSpeaker.q(function () {
			if (rspkr.ui.getActivePlayer()) {
				rspkr.ui.getActivePlayer().stop();
				rspkr.ui.getActivePlayer().close();
			}
		});
	},

};

site.inits.push('site.topContent.init()');
